module.exports = __webpack_public_path__ + "img/baipei2.4fcc7912.jpg";